import { Alpine, Livewire } from "../../vendor/livewire/livewire/dist/livewire.esm";
import "./base";
import "./utils/echo";

import mapboxStatic from "./alpine/data/mapbox-static";
import uppy from "./alpine/data/uppy";

import { createDraggable, createTimer } from "animejs";
import autofill from "./alpine/data/autofill";
import carousel from "./alpine/data/carousel";
import instantsearch from "./alpine/data/instantsearch";
import mapboxAutocomplete from "./alpine/data/mapbox-autocomplete";
import muuri from "./alpine/data/muuri";
import browserNotifications from "./alpine/stores/browser-notifications";
import pushNotifications from "./alpine/stores/push-notifications";
import resizable from "./alpine/data/resizable";
import slider from "./alpine/data/slider";
import tiptap from "./alpine/data/tiptap";
import stripeConnect from "./alpine/data/stripe-connect";
import pwa from "./alpine/stores/pwa";
import ship24 from "./alpine/data/ship24";

window.animejs = { createDraggable, createTimer };

document.addEventListener("alpine:init", () => {
    Alpine.data("muuri", muuri);
    Alpine.data("slider", slider);
    Alpine.data("resizable", resizable);
    Alpine.data("carousel", carousel);
    Alpine.data("autofill", autofill);
    Alpine.data("uppy", uppy);
    Alpine.data("mapboxStatic", mapboxStatic);
    Alpine.data("mapboxAutocomplete", mapboxAutocomplete);
    Alpine.data("tiptap", tiptap);
    Alpine.data("instantsearch", instantsearch);
    Alpine.data("stripeConnect", stripeConnect);
    Alpine.data("ship24", ship24);

    Alpine.store("pushNotifications", pushNotifications());
    Alpine.store("browserNotifications", browserNotifications());
    Alpine.store("pwa", pwa());
});

Livewire.interceptRequest(({ request }) => {
    request.options.headers["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
});

Livewire.start();
